export const action_origin = "MEMBER";
export const enroll_prime_pids = process.env.VUE_APP_ENROLLPRIME_PIDS
    ? process.env.VUE_APP_ENROLLPRIME_PIDS.split(',').map(Number)
    : [];


export function checkEnrollPrime(pid) {
    if (Array.isArray(pid)) {
        return pid.some(id => enroll_prime_pids.includes(id));
    }
    return enroll_prime_pids.includes(pid);
}
